// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__bWB89","label":"Category_label__36KDW","content":"Category_content__2Ar-N","header":"Category_header__1HjD2","location":"Category_location__hwMhJ"};